module.exports = __webpack_public_path__ + "assets/img/footer_logo_elemen4.de483092.png";